import React from 'react';

import Image from '@/core/components/Image';
import SystemMessage from '@/core/components/messages/SystemMessage';
import { useComponentsContext } from '@/core/lib/components/components.context';
import { useNativeContext } from '@/core/lib/native/native.context';

interface GingerAdProps {
  displayEvent: GingerAdEvent;
  isNice: boolean | null;
  isPunctual: boolean | null;
}

export type GingerAdEvent = 'conversation' | 'donation';

const GingerAd: React.FC<GingerAdProps> = ({ displayEvent, isNice, isPunctual }) => {
  const { AdLinkWithStatsApiCall } = useComponentsContext();
  const { isNative } = useNativeContext();

  const href = isNative ? 'https://sovendus.com/directlink/021c18ce-9e7d-4731-b78c-656930e41d00' : ' https://sovendus.com/directlink/0e51a2af-8b53-4664-baa5-c8b084ce0061';

  if (displayEvent === 'donation') {
    return (
      <AdLinkWithStatsApiCall href={href} adData="donation" apiUrl="/api/stats/ad/ginger-ad">
        <div className="mx-auto flex w-67 flex-col items-center">
          <Image src="/assets/ad/gingerAd/gift.png" type="png" alt="Cadeau" className="mx-auto size-16" />
          <p className="mb-4 text-16 font-semibold">1 petit cadeau vous attend&nbsp;!</p>
          <p className="text-button-medium w-full rounded-2 border-1.5 border-solid border-stroke-button-primary-default bg-bg-button-primary-default px-3 py-2 text-center font-medium text-content-button-primary focus-visible:border-stroke-button-primary-pressed focus-visible:bg-bg-button-primary-pressed focus-visible:outline-none">
            Choisissez votre cadeau
          </p>
        </div>
      </AdLinkWithStatsApiCall>
    );
  }

  const isDisplayGingerAd = isNice !== null && isPunctual !== null;

  if (!isDisplayGingerAd) {
    return null;
  }

  return (
    <SystemMessage>
      <AdLinkWithStatsApiCall href={href} adData="conversation" apiUrl="/api/stats/ad/ginger-ad">
        <div className="flex flex-col items-center">
          <Image src="/assets/ad/gingerAd/gift.png" type="png" alt="Cadeau" className="mx-auto size-10" />
          <p className="mb-4 text-12 font-semibold">1 petit cadeau vous attend&nbsp;!</p>
          <p className="text-button-small w-full rounded-2 border-1.5 border-solid border-stroke-button-primary-default bg-bg-button-primary-default p-1 text-center font-medium text-content-button-primary focus-visible:border-stroke-button-primary-pressed focus-visible:bg-bg-button-primary-pressed focus-visible:outline-none">
            Choisissez votre cadeau
          </p>
        </div>
      </AdLinkWithStatsApiCall>
    </SystemMessage>
  );
};

export default GingerAd;
